export default __webpack_public_path__ + "static/media/fund-Card-banner-diversified.2144499a.png";